module.exports = __webpack_public_path__ + "static/media/kpmg-email-logo.7d679d8b.png";